// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as SupplierSelect from "../Supplier/SupplierSelect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProducerSelect from "./CatalogProducerSelect.res.js";
import * as ProductReferenceTableCell from "../Product/ProductReferenceTableCell.res.js";
import * as CatalogCategorySelectFilter from "./CatalogCategorySelectFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query VariantsQuery($search: String, $filterBy: InputVariantsQueryFilter, $after: String, $first: Int)  {\nvariants(search: $search, filterBy: $filterBy, after: $after, first: $first)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncreatedAt  \nformattedName  \nname  \nproduct  {\n__typename  \nid  \nname  \nkind  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \nsupplier  {\n__typename  \ncompanyName  \n}\n\nformattedCategory  \nalcoholVolume  \nvariantPrices(first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nvalueIncludingTax  \nfromQuantity  \nprice  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variants;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    variants: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.product;
        let value$3 = value$2.kind;
        let tmp;
        switch (value$3) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$2.color;
        let tmp$1;
        if (value$4 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$4) {
            case "AMBER" :
              tmp$2 = "AMBER";
              break;
            case "BLACK" :
              tmp$2 = "BLACK";
              break;
            case "BLOND" :
              tmp$2 = "BLOND";
              break;
            case "DARK" :
              tmp$2 = "DARK";
              break;
            case "ORANGE" :
              tmp$2 = "ORANGE";
              break;
            case "RED" :
              tmp$2 = "RED";
              break;
            case "ROSE" :
              tmp$2 = "ROSE";
              break;
            case "WHITE" :
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$5 = value$2.wineType;
        let tmp$3;
        if (value$5 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$5) {
            case "EFFERVESCENT" :
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL" :
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$6 = value$2.whiteWineType;
        let tmp$5;
        if (value$6 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$6) {
            case "DRY" :
              tmp$6 = "DRY";
              break;
            case "SEMIDRY" :
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT" :
              tmp$6 = "SOFT";
              break;
            case "SWEET" :
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$7 = value$2.beerType;
        let value$8 = value$2.producer;
        let value$9 = value$2.designation;
        let value$10 = value$2.family;
        let value$11 = value$2.region;
        let value$12 = value$2.country;
        let value$13 = value$2.tax;
        let value$14 = value$1.stockKeepingUnit;
        let value$15 = value$1.priceLookUpCode;
        let value$16 = value$1.internalCode;
        let value$17 = value$1.supplier;
        let value$18 = value$1.formattedCategory;
        let value$19 = value$1.alcoholVolume;
        let value$20 = value$1.variantPrices;
        let value$21 = value$20.edges;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            formattedName: value$1.formattedName,
            name: value$1.name,
            product: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              kind: tmp,
              color: tmp$1,
              wineType: tmp$3,
              whiteWineType: tmp$5,
              beerType: !(value$7 == null) ? value$7 : undefined,
              producer: !(value$8 == null) ? value$8 : undefined,
              designation: !(value$9 == null) ? value$9 : undefined,
              family: !(value$10 == null) ? value$10 : undefined,
              region: !(value$11 == null) ? value$11 : undefined,
              country: !(value$12 == null) ? value$12 : undefined,
              tax: {
                __typename: value$13.__typename,
                value: value$13.value
              }
            },
            stockKeepingUnit: !(value$14 == null) ? value$14 : undefined,
            priceLookUpCode: !(value$15 == null) ? value$15 : undefined,
            internalCode: !(value$16 == null) ? value$16 : undefined,
            supplier: !(value$17 == null) ? ({
                __typename: value$17.__typename,
                companyName: value$17.companyName
              }) : undefined,
            formattedCategory: !(value$18 == null) ? value$18 : undefined,
            alcoholVolume: !(value$19 == null) ? value$19 : undefined,
            variantPrices: {
              __typename: value$20.__typename,
              edges: value$21.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.fromQuantity;
                let value$3 = value$1.price;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    valueIncludingTax: value$1.valueIncludingTax,
                    fromQuantity: !(value$2 == null) ? value$2 : undefined,
                    price: !(value$3 == null) ? ({
                        __typename: value$3.__typename,
                        id: value$3.id
                      }) : undefined
                  }
                };
              })
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variantPrices;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.price;
      let price;
      if (value$2 !== undefined) {
        let value$3 = value$2.id;
        let value$4 = value$2.__typename;
        price = {
          __typename: value$4,
          id: value$3
        };
      } else {
        price = null;
      }
      let value$5 = value$1.fromQuantity;
      let fromQuantity = value$5 !== undefined ? value$5 : null;
      let value$6 = value$1.valueIncludingTax;
      let value$7 = value$1.__typename;
      let node = {
        __typename: value$7,
        valueIncludingTax: value$6,
        fromQuantity: fromQuantity,
        price: price
      };
      let value$8 = value.__typename;
      return {
        __typename: value$8,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let variantPrices = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.alcoholVolume;
    let alcoholVolume = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.formattedCategory;
    let formattedCategory = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.supplier;
    let supplier;
    if (value$7 !== undefined) {
      let value$8 = value$7.companyName;
      let value$9 = value$7.__typename;
      supplier = {
        __typename: value$9,
        companyName: value$8
      };
    } else {
      supplier = null;
    }
    let value$10 = value$1.internalCode;
    let internalCode = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.priceLookUpCode;
    let priceLookUpCode = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.product;
    let value$14 = value$13.tax;
    let value$15 = value$14.value;
    let value$16 = value$14.__typename;
    let tax = {
      __typename: value$16,
      value: value$15
    };
    let value$17 = value$13.country;
    let country = value$17 !== undefined ? value$17 : null;
    let value$18 = value$13.region;
    let region = value$18 !== undefined ? value$18 : null;
    let value$19 = value$13.family;
    let family = value$19 !== undefined ? value$19 : null;
    let value$20 = value$13.designation;
    let designation = value$20 !== undefined ? value$20 : null;
    let value$21 = value$13.producer;
    let producer = value$21 !== undefined ? value$21 : null;
    let value$22 = value$13.beerType;
    let beerType = value$22 !== undefined ? value$22 : null;
    let value$23 = value$13.whiteWineType;
    let whiteWineType = value$23 !== undefined ? (
        value$23 === "SWEET" ? "SWEET" : (
            value$23 === "SEMIDRY" ? "SEMIDRY" : (
                value$23 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : null;
    let value$24 = value$13.wineType;
    let wineType = value$24 !== undefined ? (
        value$24 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : null;
    let value$25 = value$13.color;
    let color = value$25 !== undefined ? (
        value$25 === "ORANGE" ? "ORANGE" : (
            value$25 === "RED" ? "RED" : (
                value$25 === "AMBER" ? "AMBER" : (
                    value$25 === "DARK" ? "DARK" : (
                        value$25 === "BLACK" ? "BLACK" : (
                            value$25 === "BLOND" ? "BLOND" : (
                                value$25 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$26 = value$13.kind;
    let kind = value$26 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$26 === "BEER" ? "BEER" : (
            value$26 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$27 = value$13.name;
    let value$28 = value$13.id;
    let value$29 = value$13.__typename;
    let product = {
      __typename: value$29,
      id: value$28,
      name: value$27,
      kind: kind,
      color: color,
      wineType: wineType,
      whiteWineType: whiteWineType,
      beerType: beerType,
      producer: producer,
      designation: designation,
      family: family,
      region: region,
      country: country,
      tax: tax
    };
    let value$30 = value$1.name;
    let value$31 = value$1.formattedName;
    let value$32 = value$1.createdAt;
    let value$33 = Scalar.Datetime.serialize(value$32);
    let value$34 = value$1.id;
    let value$35 = value$1.__typename;
    let node = {
      __typename: value$35,
      id: value$34,
      createdAt: value$33,
      formattedName: value$31,
      name: value$30,
      product: product,
      stockKeepingUnit: stockKeepingUnit,
      priceLookUpCode: priceLookUpCode,
      internalCode: internalCode,
      supplier: supplier,
      formattedCategory: formattedCategory,
      alcoholVolume: alcoholVolume,
      variantPrices: variantPrices
    };
    let value$36 = value.__typename;
    return {
      __typename: value$36,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.hasNextPage;
  let hasNextPage = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.endCursor;
  let endCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$8 = value$1.__typename;
  let variants = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    variants: variants
  };
}

function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectNullableStringEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a !== undefined ? a : undefined
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputVariantsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.stockKeepingUnit;
  let a$2 = inp.ean13;
  let a$3 = inp.active;
  let a$4 = inp.archived;
  let a$5 = inp.createdAt;
  let a$6 = inp.updatedAt;
  let a$7 = inp.categoryId;
  let a$8 = inp.supplierId;
  let a$9 = inp.stock;
  let a$10 = inp.producer;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    stockKeepingUnit: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    ean13: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    active: a$3 !== undefined ? ({
        _equals: a$3._equals
      }) : undefined,
    archived: a$4 !== undefined ? (
        a$4 === "ONLY" ? "ONLY" : (
            a$4 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    createdAt: a$5 !== undefined ? serializeInputObjectDateFilter(a$5) : undefined,
    updatedAt: a$6 !== undefined ? serializeInputObjectDateFilter(a$6) : undefined,
    categoryId: a$7 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$7) : undefined,
    supplierId: a$8 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$8) : undefined,
    stock: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined,
    producer: a$10 !== undefined ? ({
        _equals: a$10._equals
      }) : undefined
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.after;
  let a$3 = inp.first;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputVariantsQueryFilter(a$1) : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined
  };
}

function makeVariables(search, filterBy, after, first) {
  return {
    search: search,
    filterBy: filterBy,
    after: after,
    first: first
  };
}

function makeInputObjectInputVariantsQueryFilter(shopIds, stockKeepingUnit, ean13, active, archived, createdAt, updatedAt, categoryId, supplierId, stock, producer, param) {
  return {
    shopIds: shopIds,
    stockKeepingUnit: stockKeepingUnit,
    ean13: ean13,
    active: active,
    archived: archived,
    createdAt: createdAt,
    updatedAt: updatedAt,
    categoryId: categoryId,
    supplierId: supplierId,
    stock: stock,
    producer: producer
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectNullableStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    filterBy: undefined,
    after: undefined,
    first: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function rowsFromEdgesData(data, priceId) {
  return data.map(edge => {
    let hasValidVariantPrice = Stdlib_Option.isSome(edge.node.variantPrices.edges.find(param => {
      let node = param.node;
      let match = node.fromQuantity;
      if (match !== undefined && match !== 1) {
        return false;
      }
      let match$1 = node.price;
      if (match$1 !== undefined && match$1.id === priceId) {
        return node.valueIncludingTax > 0;
      } else {
        return false;
      }
    }));
    return {
      id: edge.node.id,
      createdAt: edge.node.createdAt,
      formattedName: edge.node.formattedName,
      productKind: edge.node.product.kind,
      information: {
        productName: edge.node.product.name,
        variantName: edge.node.name,
        sku: edge.node.stockKeepingUnit,
        plu: Stdlib_Option.map(edge.node.priceLookUpCode, plu => plu.toString()),
        internalCode: edge.node.internalCode,
        color: edge.node.product.color,
        producerName: edge.node.product.producer,
        designation: edge.node.product.designation,
        productFamily: edge.node.product.family,
        wineType: edge.node.product.wineType,
        whiteWineType: edge.node.product.whiteWineType,
        beerType: edge.node.product.beerType,
        region: edge.node.product.region,
        country: Stdlib_Option.getOr(edge.node.product.country, "—"),
        categoryName: Stdlib_Option.getOr(edge.node.formattedCategory, "—"),
        supplierName: Stdlib_Option.map(edge.node.supplier, supplier => supplier.companyName),
        alcoholVolume: Stdlib_Option.map(edge.node.alcoholVolume, alcoholVolume => I18n.decimalFormat(undefined, undefined, 1, undefined, alcoholVolume) + "°")
      },
      hasValidVariantPrice: hasValidVariantPrice
    };
  });
}

let columns = [{
    key: "product",
    name: I18n.t("Product"),
    render: param => {
      let disabled = param.disabled;
      let data = param.data;
      let badgeNew = DateHelpers.diffInHours(new Date(), data.createdAt) <= 24 ? ({
          variation: "information",
          text: I18n.t("New")
        }) : undefined;
      let match = data.hasValidVariantPrice;
      return JsxRuntime.jsx(ProductReferenceTableCell.make, {
        badge: badgeNew,
        disabled: disabled,
        errorMessage: disabled && !match ? I18n.t("No retail prices found with the selected price list") : undefined,
        productKind: data.productKind,
        information: data.information
      });
    }
  }];

function setDefaultOrderedQuantityValue(productInput) {
  if (productInput.TAG === "Unit") {
    let product = productInput.product;
    return {
      TAG: "Unit",
      product: {
        id: product.id,
        identifier: product.identifier,
        stockKeepingUnit: product.stockKeepingUnit,
        name: product.name,
        description: product.description,
        capacityUnit: product.capacityUnit,
        stock: product.stock,
        packaging: product.packaging,
        quantity: 1,
        expectedQuantity: product.expectedQuantity,
        unitPrice: product.unitPrice,
        fees: product.fees,
        discounts: product.discounts,
        tax: product.tax
      }
    };
  }
  let product$1 = productInput.product;
  return {
    TAG: "Bulk",
    product: {
      id: product$1.id,
      identifier: product$1.identifier,
      stockKeepingUnit: product$1.stockKeepingUnit,
      name: product$1.name,
      description: product$1.description,
      capacityUnit: product$1.capacityUnit,
      stock: product$1.stock,
      packaging: product$1.packaging,
      quantity: 1,
      expectedQuantity: product$1.expectedQuantity,
      unitPrice: product$1.unitPrice,
      fees: product$1.fees,
      discounts: product$1.discounts,
      tax: product$1.tax
    },
    precision: productInput.precision
  };
}

let make = React.memo(props => {
  let onCommit = props.onCommit;
  let selectedProducts = props.selectedProducts;
  let renderStartText = () => {
    let length = selectedProducts.length;
    let shouldBePrimaryView = length > 0;
    let formattedText = length.toString() + ` ` + I18n.t(I18n.isPlural(length) ? "selected products" : "selected product");
    return JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: formattedText,
        variation: shouldBePrimaryView ? "primary" : "neutral",
        weight: shouldBePrimaryView ? "strong" : "regular"
      })
    });
  };
  let onCommit$1 = () => onCommit(selectedProducts);
  return JsxRuntime.jsx(Modal.make, {
    children: props.children,
    opened: props.opened,
    title: I18n.t("Product append"),
    variation: "secondary",
    compact: false,
    backgroundColor: "#fefefe",
    renderStartText: renderStartText,
    abortButtonText: I18n.t("Cancel"),
    allowCommit: selectedProducts.length !== 0,
    commitButtonTone: "brand",
    commitButtonText: I18n.t("Add products"),
    commitButtonCallback: onCommit$1,
    onRequestClose: props.onRequestClose
  });
});

let PickerModal = {
  make: make
};

function initialState(filters) {
  return {
    searchQuery: "",
    filters: filters,
    selectedProducts: []
  };
}

function make$1(state, action) {
  switch (action.TAG) {
    case "Searched" :
      return {
        searchQuery: action._0,
        filters: state.filters,
        selectedProducts: state.selectedProducts
      };
    case "FiltersUpdated" :
      return {
        searchQuery: state.searchQuery,
        filters: action._0(state.filters),
        selectedProducts: state.selectedProducts
      };
    case "ProductSelectionUpdated" :
      let allProducts = action._1;
      let tableSelection = action._0;
      let prev = state.selectedProducts;
      let selectedProducts;
      selectedProducts = typeof tableSelection !== "object" ? prev : Stdlib_Array.filterMap(tableSelection._0, selectedRowId => allProducts.concat(prev).find(row => row.id === selectedRowId));
      return {
        searchQuery: state.searchQuery,
        filters: state.filters,
        selectedProducts: selectedProducts
      };
    case "ResetSearchAndFilters" :
      let initialState = action._0;
      return {
        searchQuery: initialState.searchQuery,
        filters: initialState.filters,
        selectedProducts: state.selectedProducts
      };
  }
}

let Reducer = {
  initialState: initialState,
  make: make$1
};

function makeVariables$1(search, filters, after, param) {
  let id = filters.shopId;
  let category = filters.category;
  let tmp;
  if (category !== undefined) {
    let categoryId = category.id;
    tmp = {
      _equals: (categoryId == null) ? null : categoryId
    };
  } else {
    tmp = undefined;
  }
  let supplier = filters.supplier;
  let tmp$1;
  if (supplier !== undefined) {
    let supplierId = supplier.id;
    tmp$1 = {
      _equals: (supplierId == null) ? null : supplierId
    };
  } else {
    tmp$1 = undefined;
  }
  let producer = filters.producer;
  return makeVariables(search, makeInputObjectInputVariantsQueryFilter(id !== undefined ? ({
      _in: [id]
    }) : undefined, undefined, undefined, {
    _equals: true
  }, undefined, undefined, undefined, tmp, tmp$1, undefined, producer !== undefined ? ({
      _equals: producer
    }) : undefined, undefined), after, 20);
}

function CatalogLabelProductsPickerModalTable(props) {
  let __disabledIds = props.disabledIds;
  let priceId = props.priceId;
  let shopId = props.shopId;
  let opened = props.opened;
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let initialState_filters = {
    shopId: shopId
  };
  let initialState_selectedProducts = [];
  let initialState = {
    searchQuery: "",
    filters: initialState_filters,
    selectedProducts: initialState_selectedProducts
  };
  let match = React.useReducer(make$1, initialState);
  let dispatch = match[1];
  let state = match[0];
  let query = use(undefined, undefined, undefined, undefined, "NetworkOnly", "CacheFirst", undefined, true, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shopId), undefined, makeVariables$1(state.searchQuery, state.filters, undefined, undefined));
  let asyncResult = ApolloHelpers.useQueryResultToAsyncResultWithVariablesReloading2(query, state.searchQuery, shopId);
  let data = AsyncResult.mapOk(asyncResult, data => rowsFromEdgesData(data.variants.edges, priceId));
  React.useEffect(() => {
    if (!opened && state.searchQuery !== "") {
      dispatch({
        TAG: "Searched",
        _0: ""
      });
    }
  }, [opened]);
  let onLoadMore = React.useCallback(() => {
    if (typeof asyncResult !== "object") {
      return;
    }
    if (asyncResult.TAG !== "Done") {
      return;
    }
    let data = asyncResult._0;
    if (data.TAG !== "Ok") {
      return;
    }
    let data$1 = data._0;
    if (data$1.variants.pageInfo.hasNextPage === true) {
      query.fetchMore(undefined, undefined, makeVariables$1(state.searchQuery, state.filters, data$1.variants.pageInfo.endCursor, undefined), (prevResult, param) => {
        let fetchMoreResult = param.fetchMoreResult;
        if (fetchMoreResult === undefined) {
          return prevResult;
        }
        let newVariants = fetchMoreResult.variants;
        return {
          variants: {
            __typename: newVariants.__typename,
            pageInfo: newVariants.pageInfo,
            totalCount: newVariants.totalCount,
            edges: prevResult.variants.edges.concat(newVariants.edges)
          }
        };
      }, undefined);
      return;
    }
  }, [asyncResult]);
  let onSelectChange = React.useCallback(selection => {
    let rowsData;
    if (typeof data !== "object") {
      rowsData = data === "NotAsked" ? [] : [];
    } else if (data.TAG === "Reloading") {
      let data$1 = data._0;
      rowsData = data$1.TAG === "Ok" ? data$1._0 : [];
    } else {
      let data$2 = data._0;
      rowsData = data$2.TAG === "Ok" ? data$2._0 : [];
    }
    dispatch({
      TAG: "ProductSelectionUpdated",
      _0: selection,
      _1: rowsData
    });
  }, [
    data,
    disabledIds
  ]);
  let disabledRowsKeys;
  if (typeof data !== "object" || data.TAG !== "Done") {
    disabledRowsKeys = disabledIds;
  } else {
    let rows = data._0;
    disabledRowsKeys = rows.TAG === "Ok" ? disabledIds.concat(Stdlib_Array.filterMap(rows._0, row => {
        if (!row.hasValidVariantPrice) {
          return row.id;
        }
      })) : disabledIds;
  }
  let filters = [
    JsxRuntime.jsx(SupplierSelect.make, {
      size: "compact",
      label: I18n.t("Supplier"),
      preset: "filter",
      showDefaultItems: true,
      hideOverlayFooter: true,
      shopId: shopId,
      value: state.filters.supplier,
      onChange: supplier => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.supplier = supplier;
          return newrecord;
        }
      })
    }),
    JsxRuntime.jsx(CatalogCategorySelectFilter.make, {
      shopId: shopId,
      value: state.filters.category,
      onChange: category => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.category = category;
          return newrecord;
        }
      })
    }),
    JsxRuntime.jsx(CatalogProducerSelect.make, {
      shopId: shopId,
      value: state.filters.producer,
      onChange: producer => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.producer = producer;
          return newrecord;
        }
      })
    })
  ];
  let placeholderEmptyState = JsxRuntime.jsx(EmptyState.make, {
    illustration: Illustration.noResultFound,
    title: I18n.t("No result were found."),
    text: I18n.t("Try again with another keyword/filter or:"),
    children: JsxRuntime.jsx(Button.make, {
      label: I18n.t("Clear search query and filters"),
      onPress: () => dispatch({
        TAG: "ResetSearchAndFilters",
        _0: initialState
      })
    })
  });
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(AnimatedRender.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(TableView.make, {
          data: data,
          columns: columns,
          keyExtractor: row => row.id,
          disabledRowsKeys: disabledRowsKeys,
          selectionEnabled: true,
          selectAllEnabled: false,
          hideReloadingPlaceholder: true,
          compactRows: true,
          placeholderEmptyState: placeholderEmptyState,
          searchQuery: state.searchQuery,
          searchPlaceholder: I18n.t("Search product"),
          filters: filters,
          onSearchQueryChange: value => dispatch({
            TAG: "Searched",
            _0: value
          }),
          onLoadMore: onLoadMore,
          onSelectChange: onSelectChange
        }),
        style: {
          display: "flex",
          maxHeight: "70vh",
          minHeight: "70vh"
        }
      }),
      displayed: opened,
      animation: "fadePopinTranslation",
      duration: 300
    }),
    opened: opened,
    selectedProducts: state.selectedProducts,
    onCommit: props.onCommit,
    onRequestClose: props.onRequestClose
  });
}

let make$2 = React.memo(CatalogLabelProductsPickerModalTable, (oldProps, newProps) => {
  if (oldProps.opened === newProps.opened && oldProps.shopId === newProps.shopId) {
    return oldProps.priceId === newProps.priceId;
  } else {
    return false;
  }
});

export {
  Query,
  rowsFromEdgesData,
  columns,
  setDefaultOrderedQuantityValue,
  PickerModal,
  Reducer,
  makeVariables$1 as makeVariables,
  make$2 as make,
}
/* query Not a pure module */
